import { action } from 'easy-peasy';
import { IActionSetCurrentProgramAssistant } from '../types';

const setCurrentProgramAssistant: IActionSetCurrentProgramAssistant = action((state, payload) => {
  state.current = payload;
});

export default setCurrentProgramAssistant;
